export const Subtext = () => {
  return (
    <p className="app-subtext">
      İster yeni tarifler keşfedip dene, ister elindeki malzemeleri kullanarak
      yapabileceğin yemekleri öğren.{" "}
      <span
        style={{
          fontWeight: 700,
        }}
      >
        Bundle{" "}
        <span
          style={{
            color: "var(--bundle-red)",
          }}
        >
          AI{" "}
        </span>
        ile sofranı daha lezzetli hale getir!
      </span>
    </p>
  );
};
